import types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.SET_STATE]: (state, { key, value }) => {
		state[key] = value;
	}
};
